function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKioskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.55,4.19H16.27a3.06,3.06,0,0,0-3,3.06v4.58h3V8.78H31.55V33.22H16.27v-3h-3v4.58a3.06,3.06,0,0,0,3,3.06H31.55a3.07,3.07,0,0,0,3.06-3.06V7.25a3.07,3.07,0,0,0-3.06-3.06M13.23,23.25l-3.9-3.9L7.39,21.29l5.83,5.82,11-11-1.94-1.94Z",
    style: {
      fill: "#62a3ef"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKioskIcon);
export default __webpack_public_path__ + "static/media/kiosk_icon.d047e2928b16e17bd8013cbf676bc240.svg";
export { ForwardRef as ReactComponent };